import { Sport } from '__generated__/globalTypes';
import { useConfigContext } from 'contexts/config';

export const useMainSport = () => {
  const {
    currentLocation: { countryCode },
  } = useConfigContext();
  const countryCodeValue = countryCode?.toLowerCase() || '';

  switch (countryCodeValue) {
    case 'us':
      return Sport.NBA;
    default:
      return Sport.FOOTBALL;
  }
};
